import React, { Component } from 'react';
import { connect } from 'shalala';
import { Route, Switch } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

import './Sidebar.css';

import { useStore } from '../store';
import { Auth, Event } from '../support';
import GuardianRoute from '../shared/GuardianRoute';
import SociosDeNegocioRoutes from '../modulos/socios';
import Recepcion from '../modulos/recepcion/Recepcion';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import TimbradoTicketsRoutes from '../modulos/timbrado-sftp';
import Cancelaciones from '../modulos/cancelaciones/Cancelaciones';
import NavBarHeader from './components/navbar-header/NavBarHeader';
import TimbradoMasivo from '../modulos/timbrado-masivo/TimbradoMasivo';
import Autofacturacion from '../modulos/autofacturacion/Autofacturacion';
import CatalogoCliente from '../modulos/catalogo-cliente/CatalogoCliente';
import AdditionalModulesSidebar from './sidebar/AdditionalModulesSidebar';
import SessionOverrideHighlighter from '../shared/session/SessionOverrideHighlighter';
import FacturasGlobalesRoutes from '../modulos/facturas-globales/FacturasGlobalesRoutes';
import RetencionesMasivasRoute from '../modulos/retenciones-masivas/RetencionesMasivasRoute';
import AccountSuspendedHighlighter from '../admin/clientes/list/components/AccountSuspendedHighlighter';
import EmisoresSoonToExpireHighlighter from '../app/emisores/EmisoresSoonToExpireHighlighter';

class AdditionalModulesLayout extends Component {
  notification = null;

  state = {
    open: false,
    live: false,
  };

  _mounted = false;

  constructor(props) {
    super(props);

    const { empresa = {} } = Auth.getData() || {};

    this.state = {
      open: false,
      live: empresa.live || false,
    };

    this.setTenancy(empresa.live || false);

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  handleDrawerNeedsClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOnAppNeedsRefresh = () => {
    const { empresa = {} } = Auth.getData() || {};

    this.setState({
      live: empresa.live || false,
    });
  };

  setTenancy = (live) => {
    this.props.tenantActions.setPartialState({ data: { live } });
  };

  goToCompanySwitch = () => {
    this.props.history.push({
      pathname: '/app/switch',
      state: {
        from: this.props.location,
      },
    });

    this.handleOnToggleSidebar(false);
  };

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.open;

    this.setState({
      open: state,
    });
  };

  goToActivation = () => {
    this.props.history.push('/cuenta/config/activacion');

    window.ToastManager.hide(this.notification);
  };

  handleOnTenancyChange = async (live) => {
    await this.props.tenantActions.live(live);

    const { error } = this.props.tenant;

    if (!error) {
      const {
        data: info,
        data: { live: tenancy },
      } = this.props.tenant;

      const original = Auth.getData();

      const data = {
        ...original,
        empresa: {
          ...info,
        },
      };

      Auth.setData(data);

      this.setTenancy(tenancy);

      await window.resetApp();
    } else {
      if (error.code === 'account_not_activated') {
        this.setState({
          live: false,
        });

        this.notification = window.ToastManager.show({
          variant: 'info',
          title: 'Notificación',
          message: (
            <div>
              <div className="pb-2">{error.message}</div>
              <div className="text-right">
                <Button
                  type="button"
                  className="ml-auto"
                  onClick={() => this.props.history.push('/cuenta/config/activacion')}
                >
                  Ir a mi cuenta
                </Button>
              </div>
            </div>
          ),
        });
      } else {
        window.ToastManager.show({
          variant: 'info',
          title: 'Notificación',
          message: error.message,
        });
      }
    }
  };

  render() {
    const { open } = this.state;
    const {
      busy,
      data: { live = false },
    } = this.props.tenant;

    const sidebarClassName = !!open ? 'sidebar-open' : '';

    return (
      <Container
        fluid
        className={`app-wrapper ${sidebarClassName}`}
      >
        <NavBarHeader
          fluid={false}
          onToggleSidebar={this.handleOnToggleSidebar}
        />

        <HttpErrorMonitor />

        <AccountSuspendedHighlighter />

        <EmisoresSoonToExpireHighlighter />

        <SessionOverrideHighlighter />

        <div
          className="sidebar-backdrop"
          onClick={this.handleOnToggleSidebar.bind(this, false)}
        ></div>

        <div className="d-block d-lg-none d-xl-none">
          <AdditionalModulesSidebar
            live={live}
            open={open}
            busy={busy}
            onCompanyClick={this.goToCompanySwitch}
            onTenancyChange={this.handleOnTenancyChange.bind(this)}
            onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
          />
        </div>

        <div className="app-container container">
          <div className="d-none d-lg-flex d-xl-flex">
            <AdditionalModulesSidebar
              live={live}
              open={open}
              busy={busy}
              onCompanyClick={this.goToCompanySwitch}
              onTenancyChange={this.handleOnTenancyChange.bind(this)}
              onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
            />
          </div>

          <div className="main-container">
            <div className="page-container">
              <Switch>
                <GuardianRoute
                  path="/modulos/timbrado-masivo"
                  component={TimbradoMasivo}
                  can="facturacion_masiva.access"
                />
                <GuardianRoute
                  path="/modulos/retenciones-masivas"
                  component={RetencionesMasivasRoute}
                  can="retencion_masiva.access"
                />
                <GuardianRoute
                  path="/modulos/autofacturacion"
                  component={Autofacturacion}
                  can="autofacturacion.access"
                />
                <Route
                  path="/modulos/cancelaciones"
                  component={Cancelaciones}
                />
                <GuardianRoute
                  path="/modulos/fpg"
                  component={FacturasGlobalesRoutes}
                  can="autofacturacion.access"
                />
                <GuardianRoute
                  path="/modulos/socios"
                  component={SociosDeNegocioRoutes}
                  can="socios_de_negocio.access"
                />
                <GuardianRoute
                  path="/modulos/timbrado-sftp"
                  component={TimbradoTicketsRoutes}
                  can="timbrado_sftp.access"
                />
                <GuardianRoute
                  path="/modulos/catalogo-cliente"
                  component={CatalogoCliente}
                  can="catalogo_cliente.access"
                />
                <GuardianRoute
                  path="/modulos/recepcion"
                  component={Recepcion}
                  can="recepcion.access"
                />
              </Switch>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}
const mapState = (store) => {
  return { tenant: store.layouts.empresa.tenant };
};

const mapActions = (actions) => {
  return { tenantActions: actions.layouts.empresa.tenant };
};

export default connect(useStore, mapState, mapActions)(AdditionalModulesLayout);
